import React, {Component, Suspense} from "react";
import ARROW from "../media/down_arrow.svg";
import "./MediaSlideshowStyle.css";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


class MediaSlideshow extends Component{

    constructor(props){
        super(props);
        
        this.state = {
            index: 0,
            media: this.props.sources,
            images: []
        }

        console.log(this.props.sources);

        this.isImage = ['.gif','.jpg','.jpeg','.png'];
        this.isVideo =['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4'];

        var loadedImages = [];

        for(var i = 0; i < this.state.media.length; i++){
            loadedImages.push(
                <>
                    <img className="media-source" alt="project-image" src={this.state.media[i]} />
                </>
            );
        }

        this.state.images = loadedImages;
    }

    getMediaType=()=>{
        var type = "img";
        if (this.state.media == "") return type;
        for (var i = 0; i < this.isVideo.length; i++){
            if (this.state.media[this.state.index].includes(this.isVideo[i])){
                type = "video";
                return type;
            }
        }
        return type;
    }

    moveRight=()=>{
        var indx = this.state.index + 1;
        if (indx >= this.state.media.length){
            indx = 0;
        }
        this.setState({
            index: indx 
        });
    }

    moveLeft=()=>{
        var indx = this.state.index - 1;
        if (indx < 0){
            indx = this.state.media.length-1;
        }
        this.setState({
            index: indx 
        });
    }
    render(){
        const currentImage = this.state.images[this.state.index];
        console.log(currentImage);

        return (
        <Suspense fallback={<div style={{width: 200, height: 200}} />}>
        <div className="media-slideshow">
            {this.state.media.map((obj) => {
                return(
                    <link rel="preload" className="media-source" alt="project-image" href={obj} as="image" />
                )
            })}
            {this.getMediaType() == "img" ? 
        
            currentImage

            // <img className="media-source" src={this.state.media[this.state.index]}/> 
            : <video className="media-source" controls key={this.state.media[this.state.index]}> 
                <source src={this.state.media[this.state.index]}/>
            </video>}
           
            {this.state.media.length > 1 ? <div className="media-controls">
                <div className="media-left" onClick={this.moveLeft}>
                    <img src={ARROW} />
                </div>
                <div className="media-count">{(this.state.index + 1)+"/"+this.state.media.length}</div>
                <div className="media-right" onClick={this.moveRight}>
                    <img src={ARROW} />
                </div>
            </div> : <div className="media-controls"><span>1/1</span></div>}
            
        </div>
        </Suspense>
        )
    }
}

export default MediaSlideshow;